<template>
    <div>
        <admin v-if="this.$model.isAdmin||this.$model.isMinObr||this.$model.isDir"></admin>
        <teacher v-if="!this.$model.isMinObrHost"></teacher>
    </div>
</template>

<script>
import teacher from './teacher.vue'
import admin from './admin.vue'
export default {
    components: {
        teacher,
        admin
    },
    data() {
        return {
        }
    },
    created() {
        console.log(this.$model)
    }
};
</script>
